import EventEmitter from "./EventEmitter";

export default class AboutBox extends EventEmitter{
  constructor(container) {
    super();
    this.container = container;
    this.closeBtn = this.container.querySelector("button");
    this.wrapper = this.container.querySelector(".about-wrapper");
    this.linkButton = this.container.querySelector("#project-link");
    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });
    this.container.addEventListener("click", () => {
      this.hide();
    });
    this.wrapper.addEventListener("click", (e) => {
      e.stopImmediatePropagation();
    });
    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });
    this.linkButton.addEventListener("click", ()=>{
      //https://artsandculture.google.com/project/manga
      this.raiseEvent("visit_link", ["project/manga"]);
    })
  }

  show() {
    this.container.classList.remove("hidden");
    this.wrapper.classList.add("bounceInUp");
  }

  hide() {
    setTimeout(() => {
      this.container.classList.add("hidden");
      this.wrapper.classList.remove("bounceOutDown");
    }, 1000);
    this.wrapper.classList.remove("bounceInUp");
    this.wrapper.classList.add("bounceOutDown");
  }
}
